<template>
  <div style="height:100%">
    <v-card :style="'width:100%'" class="elevation-0">
      <v-container>
        <v-row class="mt-1">
          <v-col
            class="my-0 py-0"
            cols="12"
            sm="6">
            <v-form
              ref="formPatient"
              lazy-validation>
              <v-text-field
                class="my-0"
                v-model="nomeCompleto"
                :rules="nameRules"
                :counter="50"
                :maxlength="50"
                label="Nome Completo"
                outlined
                dense>
              </v-text-field>
            </v-form>
          </v-col>
          <v-col
            class="my-0 py-0"
            cols="12"
            sm="6">
            <v-row>
              <v-col
                class="mt-0 py-0"
                cols="4">
                <v-text-field
                  v-model="idade"
                  label="Idade"
                  v-mask="['#','##','###']"
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-form
                ref="formsex"
                lazy-validation>
                <v-col
                  class="py-0 pl-0"
                  cols="8">
                  <h1 class="text-left body-2 primary--text mt-n2">Sexo</h1>
                  <v-radio-group
                    v-model="genre"
                    class="mt-0"
                    :rules="sexRules"
                    :row="$vuetify.breakpoint === 'lg'? false : false">
                    <v-radio label="Masculino" value="masculino"></v-radio>
                    <v-radio label="Feminino" value="feminino"></v-radio>
                    <v-radio label="Outro" value="outro"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-form>
            </v-row>
          </v-col>
        </v-row>
        <div class="text-right">
          <v-container class="py-0">
            <v-btn
              class="mt-0 ml-0 body-2 primary--text"
              @click="adicionarPaciente"
              color="#BBDEFB"
              depressed>
              <v-icon size="12" class="mr-1">fas fa-plus</v-icon>Adicionar
            </v-btn>
            <br/>
            <snap v-if="errorListPatients" class="red--text">É necessário adicionar pelo menos uma vítima!</snap>
          </v-container>
        </div>
      </v-container>
    </v-card>
    <!--  style="overflow-y:scroll;height:73%"-->
    <v-card class="elevation-0">
      <v-container>
        <v-flex
          xs12
          v-if="pacientes.length > 0">
          <v-combobox
            :items="pacientes"
            item-text="name"
            return-object
            multiple
            v-model="pacientes"
            chips
            outlined
            hide-selected>
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="remove(data.item)"
                text-color="white"
                color="primary">
                <v-avatar left>
                  <v-icon>mdi-account-circle</v-icon>
                </v-avatar>
                <span v-if="data.item.name && data.item.age && data.item.genre"> {{ data.item.name }} - {{ data.item.age }} - {{ data.item.genre }} </span>
                <span v-else-if="data.item.name && data.item.age"> {{ data.item.name }} - {{ data.item.age }} </span>
                <span v-else-if="data.item.name && data.item.genre"> {{ data.item.name }} -  {{ data.item.genre }} </span>
                <span v-else-if="data.item.name"> {{ data.item.name }} </span>
              </v-chip>
            </template>
          </v-combobox>
        </v-flex>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
export default {
  directives:{ mask },
  name:'StepPatient',
  props: ['doctor','callObj'],
  data:()=>({
    pacientes: [],
    nomeCompleto: "",
    genre: "",
    idade: "",
    sexRules:[v => !!v || 'sexo da vítima precisa ser escolhido!'],
    nameRules:[
      v=> !!v || 'Nome da vítima precisa ser preenchido!',
      v=> (v && /^[A-Za-zàáãäâèéëêìíïîòóõöôùúüûç ]+$/.test(v)) || 'Somente letras!'
    ],
    errorListPatients:false
  }),
  mounted(){
    this.initData()
  },
  computed:{
  },
  watch:{
    callObj(value){
      this.initData()
    }
  },
  methods:{
    initData(){
      if(this.doctor && this.callObj){
        this.pacientes =  this.callObj.victims ? this.callObj.victims : []
        this.$store.dispatch('setVictimsInfoCall',this.pacientes)
      }
    },
    adicionarPaciente() {
      if(this.$refs.formPatient.validate() && this.$refs.formsex.validate()){
        let paciente = {
          name: this.nomeCompleto,
          classification: this.classification,
          age: this.idade,
          genre: this.genre
        };
        this.pacientes.push(paciente);
        this.clearPaciente();
      }
    },
    clearPaciente() {
      this.nomeCompleto = "";
      this.idade = "";
      this.genre = "";
      this.$refs.formPatient.resetValidation()
      this.$refs.formsex.resetValidation()
    },
    clearStep(){
      this.clearPaciente()
      this.pacientes = []
    },
    remove (item) {
      console.log('item', item)
      const index = this.pacientes.indexOf(item)
      console.log('index', index)
      this.pacientes.splice(index, 1)
    },
    setVictimsInfoCall(){
      if(this.pacientes && this.pacientes.length > 0){
        this.$store.dispatch('setVictimsInfoCall',this.pacientes)
        this.errorListPatients = false
        return true
      }
      this.errorListPatients = true
      setTimeout(() => {
        this.errorListPatients = false
      }, 5000);
      return false
    }
  }
}
</script>
